/**
 * RSICutler — IFR variante Cutler (com linha de sinal EMA).
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLMomentum.cs, classe
 * FML.RSICutler):
 *
 *   DIFF   = CLOSE - REF(CLOSE,1)
 *   P      = MA(MAX(DIFF,0), PERIOD)          (Cutler = MA ARITMÉTICA, não Wilder)
 *   N      = MA(ABS(MIN(DIFF,0)), PERIOD)
 *   RSI    = 100 · P / (P + N)
 *   EMARSI = EMA(REF(RSI, 1), AVERAGE)        (linha de sinal; oculta se AVERAGE=0)
 *
 * ≠ do `rsi` (Wilder) e do `rsiSma` (SMA-chinesa) do odin — Cutler suaviza
 * ganhos/perdas com MA simples. Paridade provada em rsiCutler.silverlight.test.js.
 * O DELTA (defasagem do sinal) é fixo em 1 no engine (não é AddParam).
 */
import {
  ref,
  sub,
  ma,
  max2,
  min2,
  abs,
  add,
  div,
  mul,
  ema,
} from "./silverlightDsl";
import { RSICutler as defaultOptions } from "./defaultOptionsForComputation";

const DELTA = 1;

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { period, average } = options;

    const close = data.map((d) => d.close ?? NaN);
    const diff = sub(close, ref(close, 1));
    const P = ma(max2(diff, 0), period);
    const N = ma(abs(min2(diff, 0)), period);
    const rsi = mul(div(P, add(P, N)), 100);
    const emaRsi = average > 0 ? ema(ref(rsi, DELTA), average) : null;

    const norm = (v) => (Number.isFinite(v) ? v : undefined);
    return data.map((_, i) => ({
      rsi: norm(rsi[i]),
      emaRsi: emaRsi ? norm(emaRsi[i]) : undefined,
    }));
  }

  calculator.undefinedLength = function () {
    const { period } = options;
    return period + DELTA;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
